<script>
// 外科配置
const optionsStatus = [
  {
    value: 1,
    label: '场地',
  },
  {
    value: 2,
    label: '麻醉方式',
  },
  // {
  //   value: '4',
  //   label: '',//注假名称
  // },
  // {
  //   value: 5,
  //   label: '规范手术名称/手术名称',//处理(规范)
  // },
  // {
  //   value: 6,
  //   label: '实际手术名称',//处理
  // },
  // {
  //   value: '7',
  //   label: '',//手术材料
  // },
  // {
  //   value: '8',
  //   label: '',//皮肤科注射材料
  // },
  // {
  //   value: 9,
  //   label: '注射部位',
  // },
  // {
  //   value: '10',
  //   label: '医生姓名',//医生
  // },
  {
    value: 11,
    label: '麻醉医生',
  },
  {
    value: 12,
    label: '洗手护士、巡回护士',
  },
  {
    value: 13,
    label: '主刀医生、实际手术医生',
  },
  {
    value: 14,
    label: '副刀医生、医助姓名',
  },

]
// 皮肤科配置
const skinOption = [
  {
    value: 2,
    label: '麻醉方式',
  },
  {
    value: 9,
    label: '注射部位',
  },
  {
    value: 15,
    label: '注射医生、医生姓名',
  },
  {
    value: 16,
    label: '护士姓名、当班护士',
  },
]
const productOption = [
  {
    value: 4,
    label: '注假名称',
  },
  {
    value: 7,
    label: '外科产品名称',
  },
  {
    value: 8,
    label: '皮肤科产品名称',
  },
]
const specData = [{
  id: '',
  menuSpec: '无',
  menuName: '无',
  price: 0,
}, {
  id: '',
  menuSpec: '其他',
  menuName: '其他',
  price: 0,
}]
export default {
  optionsStatus,
  productOption,
  skinOption,
  specData
}
</script>